import React from "react";
import { Accordion, Button, SidePanel } from "@wix/design-system";
import { SidePanelParams } from "../../../services/models/types/sidePanel.types";
import styles from "./sidePanelModal.module.css";
import Backdrop from "../Backdrop";

const SidePanelModal = ({ closePanel, showSidePanel, setShowSidePanel, items }: SidePanelParams) => {
  return (
    <>
      <div
        style={{
          right: showSidePanel ? "0px" : "-440px",
          display: `${showSidePanel ? "block" : "none"}`,
        }}
        className={styles.sidepanel_right}
      >
        <SidePanel onCloseButtonClick={closePanel}>
          <SidePanel.Header title="Filter Your Products" />
          <SidePanel.Content noPadding>
            <Accordion hideShadow skin="standard" items={items} />
          </SidePanel.Content>

          <SidePanel.Footer>
            <Button onClick={closePanel} priority="secondary" fullWidth>
              Close
            </Button>
          </SidePanel.Footer>
        </SidePanel>
      </div>
      <Backdrop showSidePanel={showSidePanel} setShowSidePanel={setShowSidePanel} />
    </>
  );
};

export default SidePanelModal;
